import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

function ProductAnalyticsNav({ onTabClick }) {
  const isActive = (pathname) => (location.pathname === pathname ? 'is-active' : '')

  return (
    <div className="card card--flat">
      <ul className="nav-tabs">
        <li className={`tab ${isActive('/profile/analytics')}`}>
          <Link to="/profile/analytics" onClick={() => onTabClick('')}>Marketplace Statistics</Link>
        </li>
        <li className={`tab ${isActive('/profile/analytics/models')}`}>
          <Link to="/profile/analytics/models" onClick={() => onTabClick('')}>My Models</Link>
        </li>
        <li className={`tab ${isActive('/profile/analytics/improvements')}`}>
          <Link to="/profile/analytics/improvements" onClick={() => onTabClick('')}>Model Improvements</Link>
        </li>
        <li className={`tab ${isActive('/profile/analytics/about')}`}>
          <Link to="/profile/analytics/about" onClick={() => onTabClick('')}>About Analytics</Link>
        </li>
      </ul>
    </div>
  )
}

ProductAnalyticsNav.propTypes = {
  onTabClick: PropTypes.func.isRequired,
}

export default ProductAnalyticsNav
